import { State } from 'ducks/reducers'
import { AdminType } from './types'

export const getAdminClients = (state: State): AdminType[] => state.admin
